import { YStack, Text, Image, XStack } from "tamagui";
import { colors } from "@styles/colors";
import Header from "@components/layout/Header";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { RiArrowLeftSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import TextCustom, { TextSize } from "@components/TextCoustom";
import developingImg from "@styles/images/developing.svg";

const Developing = () => {
  const navigate = useNavigate();

  return (
    <YStack f={1} bg={colors.bg}>
      <Header>
        <XStack ai="center" mb="$4" onPress={() => navigate(-1)}>
          <RiArrowLeftSLine size={24} color={colors.light} />
          <TextCustom str="返回" type={TextSize.SMALL} color={colors.light} bold={true} />
        </XStack>
        <YStack gap="$1" mb="$2">
          <Text fontSize={26} fow="800" color={colors.light} ls={-0.5}>
            功能開發中
          </Text>
          <Text fontSize={12} color="rgba(255,255,255,0.85)">
            敬請期待，我們正努力為您提供更好的服務
          </Text>
        </YStack>
      </Header>

      <RadiusContentWrapper>
        <YStack f={1} ai="center" jc="center" gap="$5">
          <Image source={{ uri: developingImg, width: 200, height: 200 }} width={200} height={200} resizeMode="contain" />
          <YStack ai="center" gap="$2">
            <Text fontSize={18} fow="700" color={colors.grayDark}>
              施工中...
            </Text>
            <Text fontSize={14} color={colors.gray} ta="center">
              此功能目前正在施工開發中，感謝您的耐心等待！
            </Text>
          </YStack>
        </YStack>
      </RadiusContentWrapper>
    </YStack>
  );
};

export default Developing;
